
const StrongFamiliesAndChurches = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <div
        className="relative w-full bg-cover bg-center h-[550px] flex items-center justify-center"
        style={{
          backgroundImage: "url('./images/family.png')",
        }}
      >
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative text-center px-6 md:px-12 lg:px-20 max-w-4xl">
          <h1 className="text-white text-3xl md:text-5xl font-bold leading-tight mb-4">
            How Sunday School Builds Strong Families and Strong Churches
          </h1>
          <p className="text-gray-200 text-lg md:text-xl">
            Discover how Sunday School strengthens families, supports parents, and nurtures vibrant church communities.
          </p>
        </div>
      </div>

      <section className="body--container w-full px-4 py-10 md:px-12 lg:px-24 xl:px-32">
        <div className="mx-auto max-w-4xl text-gray-800 leading-relaxed">
          <p className="mb-6">
            Sunday School is often celebrated for its role in nurturing the faith of children, but its impact extends far
            beyond the classroom. It is a cornerstone of family spiritual growth and a driving force behind healthy, vibrant
            churches. By equipping children, supporting parents, and fostering a sense of community, Sunday School plays a
            vital role in creating strong families and strong congregations.
          </p>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              1. Strengthening Faith in the Family
            </h2>
            <p>
              Sunday School provides children with foundational spiritual lessons that often spark family conversations at
              home. When children share stories, songs, and lessons they’ve learned, it opens doors for parents to engage,
              reflect, and reinforce biblical teachings, strengthening family bonds and encouraging intergenerational faith.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              2. Supporting Parents in Spiritual Education
            </h2>
            <p>
              Sunday School serves as a support system for parents, providing guidance, resources, and structured lessons
              that help them nurture their children’s spiritual growth. It complements home teaching, instilling values
              like honesty, kindness, and compassion.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              3. Teaching Biblical Values That Last a Lifetime
            </h2>
            <p>
              Children learn core biblical principles — honesty, respect, empathy, forgiveness, responsibility — which they
              carry into their households. These lessons strengthen families, guiding them to navigate life with integrity
              and grace.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              4. Fostering a Sense of Community and Belonging
            </h2>
            <p>
              Sunday School helps children feel connected to the larger faith community. Group activities, collaborative
              projects, and shared worship teach teamwork, compassion, and mutual support, while parents build encouraging
              networks that contribute to thriving church communities.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              5. Encouraging Intergenerational Relationships
            </h2>
            <p>
              Children benefit from mentorship by older believers, while adults gain renewed purpose in nurturing the next
              generation. This cycle ensures faith is passed down and celebrated across generations, strengthening the
              church community.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              6. Developing Lifelong Servants of Faith
            </h2>
            <p>
              Lessons about kindness, service, and compassion encourage children to live out their beliefs. Families become
              hubs of service, and churches flourish with members dedicated to positively impacting their communities.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              7. Preparing Children for Spiritual Leadership
            </h2>
            <p>
              Sunday School provides opportunities for children to lead, serve, and participate, developing leadership skills,
              accountability, and moral courage. This prepares them to take on future roles in the church.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              8. Reinforcing the Church’s Mission
            </h2>
            <p>
              By equipping children with faith, knowledge, and community, Sunday School strengthens the church’s ability to
              fulfill its mission of spreading love, compassion, and spiritual growth. Strong families and engaged children
              help create a vibrant, purpose-driven congregation.
            </p>
          </div>

          <div className="mt-8">
            <h2 className="text-[#000] text-2xl font-semibold mb-3 pl-4 border-l-4 border-primary">
              Conclusion: The Ripple Effect of Sunday School
            </h2>
            <p>
              Sunday School creates a ripple effect that strengthens families and fortifies churches. Children carry lessons
              home, families reinforce them, and churches benefit from a faith-rooted community. Investing in Sunday School
              helps shape strong families and strong congregations that endure for years to come.
            </p>
          </div>
        </div>
      </section>

      <section className="mb-12">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Sunday School</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Family Faith</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Church Community</p>
            <p className="bg-gray-200 text-gray-600 px-3 py-1 rounded-md">Spiritual Growth</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StrongFamiliesAndChurches;